var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-toolbar',{attrs:{"dense":"","dark":"","elevation":"0"}},[_c('v-toolbar-title',[_vm._v("Last SNe confirmed")]),_c('v-spacer')],1),_c('TableTNS',{attrs:{"confirmed":_vm.confirmed}}),_c('FooterTNS')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }